// import React from "react";
// import AntTable from "components/common/Table/AntTable";
// import PropTypes from "prop-types";
// import AttendanceTable from "../../../../../components/common/Table/AntTableTest";

// @autobind
// export default class ReportTable extends React.PureComponent {
//   static propTypes = {
//     columns: PropTypes.array,
//     dataSource: PropTypes.array,
//     properties: PropTypes.object,
//     loading: PropTypes.bool,
//     title: PropTypes.string,
//     reportBuilder: PropTypes.bool,
//   };
//   static defaultProps = {
//     reportBuilder: false,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {};
//     this.attendanceTableRef = null;
//   }
  
//   // متد برای ذخیره رفرنس به کامپوننت AttendanceTable
//   setAttendanceTableRef = (ref) => {
//     this.attendanceTableRef = ref;
//   }
  
//   // متد عمومی برای صدور فایل اکسل که می‌تواند از بیرون فراخوانی شود
//   exportToExcel = () => {
//     if (this.attendanceTableRef) {
//       this.attendanceTableRef.exportToExcel();
//     }
//   }

//   _DataSource(dataSource) {
//     let data = [];
//     dataSource.map((array) => {
//       if (!app._.isEmpty(array.body)) {
//         data.push(...array.body);
//       }
//     });
//     return data;
//   }

//   _Footer(dataSource) {
//     return dataSource[0]?.footerItems;
//   }

//   render() {
//     const {
//       columns,
//       dataSource,
//       properties,
//       title,
//       loading,
//       reportBuilder,
//       report,
//     } = this.props;
//     let _dataSource = this._DataSource(dataSource);
//     let _Footer = this._Footer(dataSource);

//     console.log("datadataSourceSourcedataSource", dataSource);
//     return (
//       <AttendanceTable
//         data={dataSource}
//         autoExport={false} // خروجی خودکار را غیرفعال می‌کنیم تا فقط با دکمه فعال شود
//         exportTitle={title || "گزارش حضور و غیاب"}
//         loading={loading}
//         properties={properties}
//         onRef={this.setAttendanceTableRef}
//       />
//     );
//   }
// }


import React from "react";
import AntTable from "components/common/Table/AntTable";
import PropTypes from "prop-types";
import printReportFormat2 from "./WindowsDailyPrint";

@autobind
export default class ReportTable extends React.PureComponent {
  static propTypes = {
    columns: PropTypes.array,
    dataSource: PropTypes.array,
    properties: PropTypes.object,
    loading: PropTypes.bool,
    title: PropTypes.string,
    reportBuilder: PropTypes.bool,
  };
  static defaultProps = {
    reportBuilder: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  _DataSource(dataSource) {
    let data = [];
    dataSource.map((array) => {
      if (!app._.isEmpty(array.body)) {
        data.push(...array.body);
      }
    });
    return data;
  }

  _Footer(dataSource) {
    return dataSource[0]?.footerItems;
  }

  render() {
    const {
      columns,
      dataSource,
      properties,
      title,
      loading,
      reportBuilder,
      report,
    } = this.props;
    let _dataSource = this._DataSource(dataSource);
    let _Footer = this._Footer(dataSource);
    const reportLabel = String((report && report.label) || title || "")
      .replace(/ي/g, "ی")
      .replace(/ك/g, "ک");
    const companyCode = String(localStorage.getItem("CompanyCode") || "");
    const reportId = report ? Number(report.id) : 0;
    const specialReportIds = [103, 139, 140, 166];
    const specialReportNames = [
      "شهرداری",
      "AI",
    ];
    const hasSpecialName = specialReportNames.some(
      (name) => reportLabel.indexOf(name) > -1
    );
    const isTotalReport = reportLabel.indexOf("مجموع") > -1;
    const hasSpecialPrint =
      (specialReportIds.indexOf(reportId) > -1 && !isTotalReport) ||
      (hasSpecialName && !isTotalReport) ||
      (companyCode === "17904" && reportId === 103 && !isTotalReport);
    const improvedPrint = hasSpecialPrint
      ? undefined
      : (selectedColumns) =>
          printReportFormat2(
            columns,
            dataSource,
            properties,
            title,
            selectedColumns
          );

    console.log("datadataSourceSourcedataSource", dataSource);
    return (
      <AntTable
        Footer={_Footer}
        reportBuilder={reportBuilder}
        loading={loading}
        columns={columns}
        dataSource={_dataSource}
        dataPrint={dataSource}
        dataExport={_dataSource}
        printTitle={title}
        rowKey="key"
        jsPagination={true}
        jsSort={true}
        jsFilter={true}
        rowSelection={false}
        haveSetting={true}
        haveExport={true}
        havePrint={true}
        haveCustomExport={true}
        haveCustomPrint={true}
        onPrint={improvedPrint}
        properties={properties}
        pagination={false}
        report={report}
      />
    );
  }
}
